import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core','appointments');
        return response;
    } catch (e) { }
}

export async function getAppointmentsTree() {
    try {
        const response = await apiGet('core',`appointment-tree`);
        return response.content;
    } catch (e) {
        return {};
    }
}


export async function getAppointments(id: string) {
    try {
        const response = await apiGet('core',`appointments/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}

export async function appointmentsAdd(appointmentsBody: any) {
    try {
        const response = await apiPost('core',`appointments`,appointmentsBody);
        return response;
    } catch (e) { }
}

export async function appointmentsUpdate(appointmentsBody: any, id: string) {
    try {
        const response = await apiPut('core',`appointments/${id}`,appointmentsBody);
        return response;
    } catch (e) { }
}

export async function appointmentsRemove(id: any) {
    try {
        const response = await apiDelete('core',`appointments/${id}`);

        return await response;
    } catch (e) { }
}